var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.item.name))]),(_vm.item.isCloudSign)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""}},on),[_c('e-svg-icon',{attrs:{"size":"sm"}},[_vm._v(_vm._s(_vm.iconName))])],1)]}}],null,false,568482144)},[_vm._v(_vm._s(_vm.tooltipText))]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }